"use strict";

exports.__esModule = true;
var _AuditLogDetails = require("./AuditLogDetails");
Object.keys(_AuditLogDetails).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AuditLogDetails[key]) return;
  exports[key] = _AuditLogDetails[key];
});